<template>
  <div class="text-center firstScreen" id="body"
       :style="{background: backgroundImage(), backgroundSize: 'cover', width: '100%'}">

    <div class="col-12 cover-container d-flex h-100 p-3 mx-auto flex-column">
      <header class="masthead mb-auto" style="backdrop-filter: " id="header">
        <div class="inner">
          <h3 class="masthead-brand">{{ header }}</h3>
          <span id="nav"></span>
          <nav class="nav nav-masthead justify-content-center">
            <a class="nav-link active" href="#">Home</a>
            <a v-for="url in urls" class="nav-link" :href="url[1]">{{url[0]}}</a>
          </nav>
        </div>
      </header>

      <main role="main" class="inner cover">
        <h1 class="cover-heading">Life is a struggle</h1>
        <p class="lead" v-html="information"></p>
      </main>

      <footer class="mastfoot mt-auto">
        <div class="inner">
          <p id="footer"><span v-html="footer()"></span><a target="_blank" href="https://beian.miit.gov.cn/">鄂ICP备17002041号-1</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      header: "MZJ ❤ OpenSource",
      urls: [
        ["Blog", "https://blog.mazhangjing.com"],
        ["Github", "https://github.com/corkine"],
        ["@Me", "about.html"]
      ],
      information: "Do not go gentle into that good night,<br/>\n" +
        "          Old age should burn and rave at close of day<br/>\n" +
        "          Rage, rage against the dying of the light."
    }
  },
  methods: {
    footer() {
      return "&copy; 2016 - " + new Date().getFullYear() + " Marvin Studio &nbsp;";
    },
    backgroundImage() {
      let list = ["cover.jpg", "cover-view.jpg", "cover-leaf.jpg"];
      return "url('/static/" + list[Math.floor(Math.random() * (list.length))] + "')"
    }
  },
}
</script>

<style>
#footer a, #footer {
  color: #d9d9d9;
}

#header {

  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
}

html, body {
  height: 100%;
}

#body {
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  color: #fff;
  text-shadow: 0 .05rem .1rem rgba(0, 0, 0, .5);
  box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5);
}

.cover-container {
  max-width: 50em;
}

#nav {
  margin-left: 180px;
}


/*
 * Header
 */
.masthead {
  margin-bottom: 2rem;
}

.masthead-brand {
  margin-bottom: 0;
}

.nav-masthead .nav-link {
  padding: .25rem 0;
  font-weight: 700;
  color: rgba(255, 255, 255, .5);
  background-color: transparent;
  border-bottom: .25rem solid transparent;
}

.nav-masthead .nav-link:hover,
.nav-masthead .nav-link:focus {
  border-bottom-color: rgba(255, 255, 255, .25);
}

.nav-masthead .nav-link + .nav-link {
  margin-left: 1rem;
}

.nav-masthead .active {
  color: #fff;
  border-bottom-color: #fff;
}

@media (min-width: 48em) {
  .masthead-brand {
    float: left;
  }

  .nav-masthead {
    float: right;
  }
}


/*
 * Cover
 */
.cover {
  padding: 0 1.5rem;
}

.cover .btn-lg {
  padding: .75rem 1.25rem;
  font-weight: 700;
}


/*
 * Footer
 */
.mastfoot {
  color: rgba(255, 255, 255, .5);
}

</style>



// WEBPACK FOOTER //
// src/App.vue